import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import ChangeRole from "components/ChangeRole";
import { changeRole, getGhostingCompanies, resetRole } from "actions/changeRoleActions";
import { getUserGhostingCompanies, isGhosting, getGhostingCompany } from "selector/userSelectors";

export const mapStateToProps = state => {
  return {
    companies: getUserGhostingCompanies(state),
    isGhosting: isGhosting(state),
    ghostingCompany: getGhostingCompany(state)
  };
};

export const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      changeRole: changeRole,
      fetchData: getGhostingCompanies,
      resetRole: resetRole
    },
    dispatch
  );
};

const ChangeRoleContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangeRole);

export default ChangeRoleContainer;
